import type { StyledFormProps } from '@/components_deprecated/Form'
import React from 'react'
import styled from 'styled-components'

interface FormProps {
  id?: string
  outerRef?: React.Ref<HTMLFormElement>

  preventDefault?: boolean
  autocomplete?: boolean

  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void

  formProps?: StyledFormProps
}

const StyledForm = styled.form<StyledFormProps>`
  display: flex;
  flex-direction: column;

  & > div + div {
    margin-top: 1rem;
  }
`

export const Form: React.JSX.CFC<FormProps> = ({
  id,
  children,

  preventDefault,
  autocomplete,
  formProps,

  outerRef,
  onSubmit,

  ...props
}) => {
  return (
    <StyledForm
      {...formProps}
      id={id}
      ref={outerRef}
      autoComplete={autocomplete ? 'on' : 'off'}
      onSubmit={event => {
        if (preventDefault) event.preventDefault()
        onSubmit(event)
      }}
      {...props}
    >
      {children}
    </StyledForm>
  )
}
